import React, { useCallback } from 'react';
import {
  Activity,
  ActivityContentView,
  ActivitySubContent,
  ActivityTitle,
  ActivityView,
  Icon,
  ItemBlock,
  ItemChange,
  LeftBarView,
  SubText,
  SubTitle,
  Text,
  Update
} from './styles';
import Avatar from '../avatar';
import { UserModel } from '../../mobx/models/user';
import { observer } from 'mobx-react-lite';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import { AVATAR_BORDER } from '../../global/constants';
dayjs.extend(relativeTime);

interface ActivityData {
  data?: UserModel;
}

const ActivityMain: React.FC<ActivityData> = (props) => {
  const { data } = props;

  const getActionLabel = useCallback((action: string | undefined): string => {
    if (!action) return '';
    if (action === 'Created') return 'Added';
    return action;
  }, []);

  return (
    <LeftBarView>
      <Activity>
        <ActivityTitle>Activity</ActivityTitle>
        <ActivityView>
          {data?.userActivity?.map((item) => {
            return (
              <ItemBlock key={item?.id}>
                <ItemChange>
                  <Icon>
                    <Avatar
                      imgSrc={data?.profile_photo || ''}
                      name={data?.name ? data?.name : 'U N'}
                      size={18}
                      borderVariant={AVATAR_BORDER.THICK}
                    />
                  </Icon>
                  <ActivityContentView>
                    <ActivitySubContent>
                      <SubTitle>
                        {data?.name} {}
                      </SubTitle>
                      <Update>
                        {getActionLabel(item?.action)}
                        {item?.type ? item?.type : ''}
                      </Update>
                      <Text>{dayjs(item?.createdTime).fromNow()}</Text>
                    </ActivitySubContent>
                    <SubText>{item?.desc}</SubText>
                  </ActivityContentView>
                </ItemChange>
              </ItemBlock>
            );
          })}
        </ActivityView>
      </Activity>
    </LeftBarView>
  );
};

export default observer(ActivityMain);
